import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import {
  CanAccess,
  AuthorizationList,
} from "../../components/template/authorization/Authorization";

export const renderColumns = (handleEdit, handleDelete) => {
  return [
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Storage",
    },
    {
      dataIndex: "address",
      key: "address",
      title: "Lokasi Storage",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_storage}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />

          <CanAccess
            role={AuthorizationList.delete_storage}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
